import React from "react";
import { Navigate } from "react-router-dom";
import { LoadingOverlay } from "../../components/LoadingOverlay";
import { useChannelAvailability, type MessagingChannel } from "../integrations/useChannelAvailability";

/**
 * Routen-Guard für Seiten, die es nur mit konfigurierter Integration gibt (SMS-/WhatsApp-Vorlagen).
 * Solange die Antwort aussteht, wird nicht umgeleitet — sonst landete jeder Direktaufruf kurz auf
 * „verboten“, bevor der Kanal bekannt ist.
 */
export function RequireChannel(props: { channel: MessagingChannel; children: React.ReactNode }) {
  const availability = useChannelAvailability();
  if (availability.isPending) return <LoadingOverlay visible scope="placeholder" />;
  if (!availability.canSend[props.channel]) return <Navigate to="/forbidden" replace />;
  return <>{props.children}</>;
}
